export const priceHandler = (price, locale = 'sv-SE', currency = 'SEK') =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0
  }).format(price)

export const prettyTitle = (item) => {
  let title = item
  if (title.includes('score')) {
    const splitName = item.split('score')
    title = `${splitName[1]}`
  }
  title = title
    .replace(/([A-Z])/g, ' $1')
    .trim()
    .replace(/(\w)(\w*)/g, function(g0, g1, g2) {
      return g1.toUpperCase() + g2.toLowerCase()
    })
  return title
}

// we shouldn't use this but its easier than mapping perfectly something
// I am still unsure how I want to proceed with.

export const flattenObject = function(object) {
  const flattenedObject = {}

  for (const i in object) {
    // eslint-disable-next-line no-prototype-builtins
    if (!object.hasOwnProperty(i)) continue

    if (typeof object[i] == 'object') {
      const flatObject = flattenObject(object[i])
      for (const x in flatObject) {
        // eslint-disable-next-line no-prototype-builtins
        if (!flatObject.hasOwnProperty(x)) continue

        flattenedObject[x] = flatObject[x]
      }
    } else {
      flattenedObject[i] = object[i]
    }
  }
  return flattenedObject
}
